module.exports = __webpack_public_path__ + "img/planIndividualMobile.66506e63.svg";